import { useState } from "react";
import { faqs } from "@/mocks/faqs";

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggle = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section id="faq" className="py-20 md:py-28 bg-dark-50">
      <div className="w-full px-4 sm:px-6 lg:px-8 xl:px-12">
        <div className="max-w-3xl mx-auto">
          <div className="text-center mb-16">
            <span className="inline-block text-dark-400 text-xs font-semibold uppercase tracking-widest mb-4">
              Česta pitanja
            </span>
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-dark-900 leading-tight mb-4">
              Imate pitanja? Imamo odgovore.
            </h2>
            <p className="text-dark-500 text-base">
              Najčešća pitanja o našim proizvodima i uslugama
            </p>
          </div>

          <div className="space-y-3">
            {faqs.map((faq, index) => (
              <div
                key={index}
                className="bg-white rounded-2xl border border-dark-100 overflow-hidden transition-all"
              >
                <button
                  onClick={() => toggle(index)}
                  className="w-full flex items-center justify-between p-5 md:p-6 text-left cursor-pointer"
                >
                  <span className="text-base font-semibold text-dark-900 pr-4">
                    {faq.question}
                  </span>
                  <span
                    className={`w-8 h-8 flex items-center justify-center rounded-full flex-shrink-0 transition-all ${
                      openIndex === index
                        ? "bg-brand-500 text-white rotate-45"
                        : "bg-dark-100 text-dark-500"
                    }`}
                  >
                    <i className="ri-add-line text-lg"></i>
                  </span>
                </button>

                <div
                  className={`transition-all duration-300 ${
                    openIndex === index
                      ? "max-h-96 opacity-100"
                      : "max-h-0 opacity-0 overflow-hidden"
                  }`}
                >
                  <div className="px-5 md:px-6 pb-5 md:pb-6 text-dark-500 text-sm leading-relaxed">
                    {faq.answer}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}